import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts"; // 用于渐变配置
import { REM_CONFIG } from "@/utils/fontSize";
const ManufacturingCycle = ({ className = "", data, }) => {
    // 模拟默认数据（开发阶段使用，后期替换为接口返回）
    const defaultData = [
        { name: "新疆化工", dailyBatch: 15, orderCompleted: 11 },
        { name: "包头化工", dailyBatch: 7, orderCompleted: 5 },
        { name: "榆林化工", dailyBatch: 10, orderCompleted: 13 },
        { name: "神木化工", dailyBatch: 7, orderCompleted: 8 },
    ];
    // 优先使用传入的接口数据，无数据时用默认模拟数据
    const dataSource = data || defaultData;
    // ECharts 配置项
    const option = {
        color: ["#0F9AFE", "#B2FFFF"], // 系列基础色（可被渐变覆盖）
        tooltip: {
            trigger: "axis", // 鼠标悬浮时触发"轴"级提示
            axisPointer: { type: "shadow" }, // 悬浮时显示"阴影"指示器
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: {
                color: "#fff",
            },
        },
        grid: {
            left: "6%",
            right: "6%",
            bottom: "6%",
            top: 60,
            containLabel: true,
        },
        legend: {
            top: "3%",
            bottom: "3%",
            data: ["日均生产批次", "订单完成数"], // 图例项（与 series.name 对应）
            textStyle: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small }, // 图例文字颜色
            left: "center",
        },
        xAxis: {
            type: "category",
            nameTextStyle: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
                padding: [30, 0, 0, 0],
            },
            data: dataSource.map((item) => item.name), // x轴类目（企业名称）
            axisLabel: {
                color: "#FFFFFF",
                fontSize: REM_CONFIG.fontSize.small,
                interval: 0,
            }, // x轴文字颜色
            axisLine: {
                lineStyle: { color: "rgba(255,255,255,0.3)" }, // x轴线半透明白色
            },
        },
        yAxis: [
            {
                type: "value",
                name: "批次（次）", // 左侧y轴名称
                nameTextStyle: {
                    color: "#FFFFFF",
                    fontSize: REM_CONFIG.fontSize.small,
                }, // y轴标题颜色
                axisLabel: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small }, // y轴刻度文字颜色
                axisLine: {
                    lineStyle: { color: "rgba(255,255,255,0.3)" }, // y轴线半透明白色
                },
                splitLine: {
                    lineStyle: {
                        color: "rgba(255,255,255,0.1)",
                        type: "dashed",
                    }, // 网格线浅灰透明
                },
            },
            {
                type: "value",
                name: "完成数（个）", // 右侧y轴名称
                nameTextStyle: {
                    color: "#FFFFFF",
                    fontSize: REM_CONFIG.fontSize.small,
                }, // y轴标题颜色
                axisLabel: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small }, // y轴刻度文字颜色
                axisLine: {
                    lineStyle: { color: "rgba(255,255,255,0.3)" }, // y轴线半透明白色
                },
                splitLine: { show: false }, // 不显示右侧y轴的网格线
            },
        ],
        series: [
            {
                name: "日均生产批次",
                type: "bar",
                data: dataSource.map((item) => item.dailyBatch), // 绑定"日均生产批次"数据
                barWidth: 16,
                itemStyle: {
                    borderRadius: [8, 8, 0, 0],
                    // 垂直渐变（上深下浅，还原设计稿视觉）
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#0F9AFE" }, // 顶部颜色
                        { offset: 1, color: "#1A6DA9" }, // 底部颜色
                    ]),
                },
                label: {
                    show: true,
                    position: "right",
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                    formatter: "{c}", // 在数值后添加单位
                },
            },
            {
                name: "订单完成数",
                type: "bar",
                yAxisIndex: 1, // 使用第二个y轴（索引为1）
                data: dataSource.map((item) => item.orderCompleted), // 绑定"订单完成数"数据
                barWidth: 16,
                itemStyle: {
                    // 垂直渐变（上深下浅，还原设计稿视觉）
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#B2FFFF" }, // 顶部颜色
                        { offset: 1, color: "#00FFFF" }, // 底部颜色
                    ]),
                    borderRadius: [8, 8, 0, 0],
                },
            },
        ],
    };
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex flex-col 
        ${className}
        min-h-0
      `, children: [_jsx(ModuleHeader, { title: "\u5236\u9020\u5468\u671F" }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(ReactEcharts, { option: option, style: { width: "100%", height: "100%" } }) })] }));
};
export default ManufacturingCycle;
